import { useState } from "react";
import { FaExternalLinkAlt } from "react-icons/fa";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { useLogout } from "../hooks/useLogout";


const LogOutButtonWithConfirmModal = ({
    tooltip_position = "top",
    type = "button",
    displayButtonText = null,
    className = "",
    variant = "outline-primary"
}) => {
    const [showModal, setShowModal] = useState(false);
    const { logout, isLoading } = useLogout({
        onSuccess: () => {
            handleCloseModal();
        }
    });

    const handleShowModal = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);

    const handleLogout = async () => {
        await logout();
    };

    return (
        <>
            <OverlayTrigger
                placement={tooltip_position}
                overlay={<Tooltip id="logout-tooltip">Log Out</Tooltip>}
            >
                <Button
                    className={className || "btn-sm"}
                    variant={variant}
                    onClick={handleShowModal}
                    type={type}
                >
                    {displayButtonText !== null ? displayButtonText : <FaExternalLinkAlt />}
                </Button>
            </OverlayTrigger>

            <Modal show={showModal} onHide={handleCloseModal} centered size="sm">
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Logout</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to log out?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal} disabled={isLoading}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={handleLogout} disabled={isLoading}>
                        {isLoading ? 'Logging out...' : 'Log Out'}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default LogOutButtonWithConfirmModal;